<template>
    <div class="right">
        <span class="popup-head">Personal data</span>
        <span class="popup-desc">
            Edit your personal data
        </span>
        <div class="lk-form" v-if="currentUser && fields">
            <div class="lk-row" v-for="(field, index) in fields" :key="index">
                <label>{{ field.name }}</label>

                <!-- VIEW MODE -->
                <!-- With value -->
                <span v-if="field.model && type === 'profile'" class="input-value">
                    {{ getFieldValue(field) }}
                </span>
                <!-- Without value -->
                <span v-else-if="!field.model && field.points && type === 'profile'" class="ball-plus">
                    +{{ field.points }} points
                </span>

                <!-- EDIT MODE -->
                <!-- Text field -->
                <div v-if="type === 'profile-edit' && !field.input" class="input-block">
                    <!-- <input v-if="field.mask" :key="'field_' + index" v-model="field.model" masked="false" v-mask="field.mask" type="text"> -->
                    <input v-model="field.model" type="text">
                </div>
                <!-- Phone field -->
                <div v-if="type === 'profile-edit' && field.input === 'phone'" class="input-block phone">
                    <masked-input v-model="field.model" :mask="phoneMask" :guide="true" type="text"/>
                </div>
                <!-- Calendar field -->
                <div v-if="type === 'profile-edit' && field.input === 'date'" class="input-block calendar">
                    <datepicker v-model="field.model" :language="datepickerLocale" :format="dateFormatter" />
                </div>
                <!-- Radio buttons -->
                <div v-if="type === 'profile-edit' && field.input === 'radio'" class="radio">
                    <div class="radio-item" v-for="(option, index) in field.options" :key="index">
                        <input type="radio" :id="field.setField+option.value" :name="field.setField" :value="option.value" v-model="field.model">
                        <label :for="field.setField+option.value">{{ option.name }}</label>
                    </div>
                </div>
                <!-- Dropdown -->
                <div v-if="type === 'profile-edit' && field.input === 'select'" class="select" :class="{'act': ~activeDropdowns.indexOf(field.id) }">
                    <input type="hidden">
                    <span v-click-outside="closeDropdown(field)" @click="toggleDropdown(field)">{{ field.model ? field.model.name : (field.empty || 'Empty') }}</span>
                    <div class="select-popup">
                        <a href="#" v-for="(option, index) in field.options" :key="index" @click.prevent="field.model = option;">{{ option.name }}</a>
                    </div>
                </div>

            </div>

            <div v-if="error" class="lk-row error">
              {{ error}}
            </div>

            <div v-if="type === 'profile'" key="profile_buttons" class="lk-row">
              <a href="#" class="red-btn edit" @click.prevent="onChange('profile-edit')">Edit</a>
            </div>
            <div v-else-if="type === 'profile-edit'" key="profile_buttons" class="lk-row">
              <a href="#" class="red-btn edit" @click.prevent="onSave" :class="{ disabled: saving }" :disabled="saving">Save</a>
              <a href="#" class="red-btn cancel" @click.prevent="onChange('profile')">Cancel</a>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
import { en } from "vuejs-datepicker/dist/locale";
import config from '../../config';

import { conformToMask } from "vue-text-mask";

const SHOW_ERROR_TIME = 3000;
const TAGS_UPDATE_TIME = 3000;

const PHONE_MASK = [
  "+",
  /\d/,
  " ",
  "(",
  /[1-9]/,
  /\d/,
  /\d/,
  ")",
  " ",
  /\d/,
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/
];

export default {
  name: "AppPopupProfile",
  components: {
    Datepicker
  },
  props: {
    type: String,
    default: "profile"
  },
  data() {
    return {
      datepickerLocale: ru,
      activeDropdowns: [],
      phoneMask: PHONE_MASK,
      error: "",
      saving: false
    };
  },
  filters: {
    gender(value) {
      return value === 1 ? "Male" : value === 2 ? "Female" : false;
    }
  },
  computed: {
    ...mapGetters(["currentUser", "remoteConfig"]),
    fields() {
      return ((this.remoteConfig && this.remoteConfig.profile) || []).map(
        item => {
          let value = this.currentUser[item.getField];
          if (item.type === "tag") {
            if (item.input === "select") {
              let value = item.options.find(item =>
                this.$options.filters["tagExist"](item.value)
              );
              item.origin = value ? Object.assign({}, value) : null;
              item.model = value ? Object.assign({}, value) : null;
            }
          } else if (item.type === "system" || item.type === "redirect") {
            let value = this.currentUser[item.getField];
            if (value && item.input === "phone") {
              let conformed = conformToMask(value, this.phoneMask, {
                guide: false
              });
              if (conformed && conformed.conformedValue) {
                value = conformed.conformedValue;
              }
            }
            item.origin = value;
            item.model = value;
          }
          return item;
        }
      );
    }
  },
  methods: {
    openDropdown(item) {
        let index = this.activeDropdowns.indexOf(item.id);
        if (!~index) this.activeDropdowns.push(item.id);
    },
    closeDropdown(item) {
      return () => {
        let index = this.activeDropdowns.indexOf(item.id);
        if (~index) this.activeDropdowns.splice(index, 1);
      }
    },
    toggleDropdown(item) {
      let index = this.activeDropdowns.indexOf(item.id);
      if (!~index) {
        this.activeDropdowns.push(item.id);
      } else {
        this.activeDropdowns.splice(index, 1);
      }
    },
    dateFormatter(date) {
      return this.$moment(date).format("D MMMM YYYY");
    },
    getFieldValue(field) {
      let value = field.model;
      if (field.type === "tag") {
        if (field.input === "select") {
          value = field.origin && field.origin.name;
        }
      } else if (field.type === "system" || field.type === "redirect") {
        if (field.filter) {
          value = this.$options.filters[field.filter](
            value,
            field.filter_params
          );
        }
      }
      return value;
    },
    onChange(value) {
      this.$emit("onChange", value);
    },
    onUserUpdate(fields) {
      return new Promise((resolve, reject) => {
//        console.log(fields, config);
        if (fields && !fields.length) return resolve();
        let params = {};
        fields.forEach(item => {
          if (item.input === "date") {
            params[item.setField] = item.model
              ? this.$moment(item.model).format("YYYY-MM-DD")
              : "";
          } else {
            params[item.setField] = item.model;
          }
        });
        if (!Object.keys(params).length) return resolve();
        this.$store.dispatch("userUpdate", params).then(resolve, reject);
      });
    },
    onTagsUpdate(tags) {

//      console.log(tags);
      return new Promise((resolve, reject) => {
        let params = {
          add: tags
            .filter(item => {
              let checkOrigin = item.origin
                ? item.model.value !== item.origin.value
                : true;
              return item.model && item.model.value && checkOrigin;
            })
            .map(item => item.model.value),
          remove: tags
            .filter(item => {
              let checkOrigin = item.origin
                ? item.model.value !== item.origin.value
                : false;
              return item.model && item.model.value && checkOrigin;
            })
            .map(item => item.origin.value)
        };
//        console.log(params);
        if (!params.add.length && !params.remove.length) return resolve();
        this.$store.dispatch("changeTags", params).then(resolve, reject);
      });
    },
    checkFirstUpdate(fields) {
      return new Promise((resolve, reject) => {
        if (fields && !fields.length) return resolve();
        let params = {
          add: []
        };

        console.log(params);

        fields.forEach(item => {
          if (!this.$options.filters["tagExist"](item.tag)) params.add.push(item.tag);
        });
        if (!params.add.length) return resolve();
        this.$store.dispatch("changeTags", params).then(resolve, reject);
      });
    },
    checkRedirect(fields){

//      console.log(fields);

      if(fields.length > 0) {

        let url = `${config.profile_redirect_url}?${fields.map(field => `${field.name}=${encodeURIComponent(field.value)}`).join('&')}`;

        window.location.href = url;

      }

    },
    onSave() {

      this.saving = true;

      let redirectField = this.fields.filter(
        item => item.type === 'redirect' && item.model !== item.origin
      ).map((item) => {

        return {
          name: item.setField,
          value: item.model,
          tag: item.tag
        };

      });

      let systemField = this.fields.filter(
        item => item.type === "system" && item.model !== item.origin
      );
      let tagsField = this.fields.filter(
        item => item.type === "tag" && item.model
      );

      let pointsFields = tagsField.concat(systemField).concat(redirectField).filter(field => field.tag);

      console.log(this.fields);

      let promises = [
        this.checkFirstUpdate(pointsFields),
        this.onUserUpdate(systemField),
        this.onTagsUpdate(tagsField)
      ];
      Promise.all(promises).then(
        () => {
          setTimeout(() => {
            console.log('saving done');
            this.error = "";
            if (systemField.length) {
              this.$store.dispatch("fetchUser").then(() => {
                if (tagsField.length) {
                  this.$store.dispatch("fetchTags").then(() => {
                    this.saving = false;
                    this.checkRedirect(redirectField);
                    this.onChange("profile");
                  });
                } else {
                  this.checkRedirect(redirectField);
                  this.saving = false;
                  this.onChange("profile");
                }
              });
            } else if (tagsField.length) {
              this.$store.dispatch("fetchTags").then(() => {
                this.checkRedirect(redirectField);
                this.saving = false;
                this.onChange("profile");
              });
            }
            else{

              this.checkRedirect(redirectField);
              this.saving = false;

            }
          }, TAGS_UPDATE_TIME);
        },
        res => {
          if (res && res.status === "error") {
            let texts =
              (this.remoteConfig && this.remoteConfig.profileError) || {};
            this.error = texts[res.status_code] || res.message;
          } else {
            this.error = "Unknown error";
          }
          this.saving = false;
          setTimeout(() => {
            if (this.error) {
              this.error = false;
            }
          }, SHOW_ERROR_TIME);
        }
      );
    }
  }
};
</script>
